// id strings for messages/checkout.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const checkout: Dict = {
  "checkout.declined":
    "Kartumu ditolak. Hubungi bankmu atau coba metode pembayaran lain.",
  "checkout.trialStarted": "Uji coba gratismu sudah dimulai!",
  "checkout.thanks": "Terima kasih atas pembelianmu!",
  "checkout.startTrial": "Mulai uji coba gratis",
  "checkout.pay": "Bayar",
};

export default checkout;
